import { app, translate } from "../app"
import { useState } from "react"
import { languages } from "../locale"
import { translations } from "../translations"
import { useWindowSize } from "usehooks-ts"
import { Button } from "./button"
import {
  acceptAnalytics,
  getGoogleAnalyticsIds,
  rejectAnalytics,
} from "./analytics"

export function CookieBanner() {
  const [isBannerVisible, setIsBannerVisible] = useState(() => !localStorage.getItem("cookieAccepted"))
  const { width } = useWindowSize()
  const isMobile = width < 768

  const isRTL = languages[app.locale]?.rtl
  const cookieContent = translate(app.page.cookie_banner)
  const trackingIds = getGoogleAnalyticsIds(app.googletag ?? [])

  const acceptCookies = () => {
    localStorage.setItem('cookieAccepted', 'true')
    acceptAnalytics(trackingIds)
    setIsBannerVisible(false)
  }

  const rejectCookies = () => {
    localStorage.setItem("cookieAccepted", "false")
    rejectAnalytics(trackingIds)
    setIsBannerVisible(false)
  }

  if (!isBannerVisible) return null

  return <div className="fixed bottom-0 left-0 right-0 z-10 text-black w-full">

    <div className=" bg-blue-100 border border-solid border-indigo-200 rounded-md mb-1 px-6 py-6 flex">
      <div className="flex-grow">
        <div style={{ textAlign: isRTL ? "right" : "left", direction: isRTL ? "rtl" : "ltr", color: "#000000" }} className="mb-3">
          {translate(translations.cookiePolicy)}
        </div>
        <div style={{ textAlign: isRTL ? "right" : "left", direction: isRTL ? "rtl" : "ltr", color: "#000000" }}>
          {translate(cookieContent)}
        </div>
      </div>
      <div className="flex gap-4 flex-wrap mr-4">
        <Button onClick={acceptCookies} aria-label="accept" className="bg-blue-500 text-white" >Accept</Button>
        <Button onClick={rejectCookies} ghost aria-label="decline" className="border-red-500 text-red-500">Decline</Button>
      </div>
    </div>
  </div>

}